import React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import IconButton from '@mui/material/IconButton';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';

const Footer = () => {
  return (
    <Box component="footer" sx={{ bgcolor: 'primary.main', color: 'white', py: 6, mt: 'auto' }}>
      <Container maxWidth="lg">
        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, justifyContent: 'space-between', alignItems: 'center' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', mb: { xs: 3, md: 0 } }}>
            {/* BBB Logo */}
            <Box sx={{ mr: 2 }}>
              <img src="/images/content/BBB-Logo.png" alt="BBB Logo" style={{ height: 100, width: 'auto' }} />
            </Box>
            <Box>
              <Typography variant="h6" gutterBottom>
                ADDRESS
              </Typography>
              <Typography variant="body2">
                19545 Causeway Blvd<br />
                Land O Lakes, FL 34638
              </Typography>
              <Typography variant="body2" sx={{ mt: 1 }}>
                <Link href="tel:813-591-6538" color="inherit">
                  (813) 591-6538
                </Link>
              </Typography>
              <Typography variant="body2" sx={{ mt: 1 }}>
                <Link href="mailto:tabithaanton@stylistinside.com" color="inherit">
                  tabithaanton@stylistinside.com
                </Link>
              </Typography>
            </Box>
          </Box>
          {/* Social and Logo Section */}
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            {/* Old Large Logo */}
            <Box sx={{ mb: 2 }}>
              <img src="/images/content/logo.jpeg" alt="Stylist Inside Large Logo" style={{ maxHeight: 150, width: 'auto', marginBottom: 16 }} />
            </Box>
            <Box sx={{ mb: 2 }}>
              <IconButton
                href="https://facebook.com/stylistinside"
                target="_blank"
                rel="noopener noreferrer"
                sx={{ color: 'white', mr: 1 }}
              >
                <FacebookIcon />
              </IconButton>
              <IconButton
                href="https://www.instagram.com/stylistinside.tabithaanton/"
                target="_blank"
                rel="noopener noreferrer"
                sx={{ color: 'white' }}
              >
                <InstagramIcon />
              </IconButton>
            </Box>
            <Typography variant="body2" align="center">
              © {new Date().getFullYear()} Stylist Inside Salon. All rights reserved.
            </Typography>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
